import { TextField } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { useFilterTextValue } from './FilterTextValue.hooks';
import { messages } from './FilterTextValue.messages';
import { FilterTextValueProps } from './FilterTextValue.types';

export const FilterTextValue = memo<FilterTextValueProps>((props) => {
    const { filter, onFilterChange } = props;

    const { value, handleChange } = useFilterTextValue(filter, onFilterChange);

    return (
        <TextField
            size='small'
            clearable={false}
            placeholder={messages.placeholder}
            value={value}
            onChange={handleChange}
        />
    );
});

FilterTextValue.displayName = 'FilterTextValue';
